import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { appRoutes } from 'routes';

import { Typography } from '@material-ui/core';

import LocationSelectInput from 'sharedComponents/LocationSelectInput';
import loanOfficerImage from './images/loanOfficer.png';

import useStyles from './useStyles';

const LocationSelect = props => {
  const { onSelect } = props;
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const handleChange = location => {
    onSelect(location);
    if (location) {
      history.push(appRoutes.loanOfficerSearchSurveyListPath());
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Typography
          className={classes.title}
          variant="h1"
          dangerouslySetInnerHTML={{
            __html: t('components.BuyerLoanOfficerSearchSurvey.LocationSelect.title'),
          }}
        />
        <Typography
          className={classes.subtitle}
          variant="subtitle1"
          dangerouslySetInnerHTML={{
            __html: t('components.BuyerLoanOfficerSearchSurvey.LocationSelect.subtitle'),
          }}
        />
        <div className={classes.control}>
          <LocationSelectInput onChange={handleChange} className={classes.select} searchIcon />
        </div>
      </div>
      <img src={loanOfficerImage} alt="" className={classes.image} />
    </div>
  );
};

LocationSelect.propTypes = {
  onSelect: PropTypes.func.isRequired,
};

export default LocationSelect;



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/LocationSelect/LocationSelect.js